import { useContext } from 'react';
import t from 'react-translate';
import useAiRolePlay from '../../hooks/use-ai-role-play';
import AiConversationContext, { Message, Role } from '../context';

type ChatTranscriptViewProps = {
  messages: Message[]
};

const ChatTranscriptView = ({ messages }: ChatTranscriptViewProps) => {
  const {
    aiRolePlayId,
  } = useContext(AiConversationContext);
  const aiRolePlay = useAiRolePlay(aiRolePlayId);
  const { aiCharacterName } = aiRolePlay;

  return (
    <div>
      {messages.map((message) => (
        <div key={message.id} className='d-flex flex-column'>
          <p className='text-regular mb-1 font-weight-bolder'>
            {message.role === Role.LEARNER
              ? t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.YOU()
              : aiCharacterName}
          </p>
          <p className='mb-4 text-regular'>{message.content}</p>
        </div>
      ))}
    </div>
  );
};

export default ChatTranscriptView;
